export default (api) => {

    const fetchSearchSuggestions = ({ search } = {}) => {
        return api.get("/api/v1/suggestion", {
            params: { text: search },
            headers: {
                "x-tenant-id": "AU_CAR_LISTING"
            }
        });
    };

    return { fetchSearchSuggestions };
};
